export const LargeSpinner = () => (
    <svg width="60" height="60" viewBox="0 0 50 50">
        <circle cx="25" cy="25" r="20" fill="none" stroke="#FD429C" strokeWidth="3" strokeLinecap="round" strokeDasharray="60 120">
            <animateTransform attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="1s" repeatCount="indefinite"></animateTransform>
        </circle>
    </svg>
);

export const SmallSpinner = () => (
    <svg width="16" height="16" viewBox="0 0 16 16">
        <circle cx="8" cy="8" r="6" fill="none" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeDasharray="18 12">
            <animateTransform attributeName="transform" type="rotate" from="0 8 8" to="360 8 8" dur="1s" repeatCount="indefinite"></animateTransform>
        </circle>
    </svg>
);